import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import '../../Assets/Css/ProjectTaskBoard.scss'
import Bookmark from "../../Assets/Images/Employee/Bookmark alt.svg";
import DoubleArrowUp from "../../Assets/Images/Employee/Chevron double arrow up.svg";

const initialColumns = {
    'notstarted': {
        name: 'Not Started',
        items: [
            { id: '1', content: 'Task 1: Not Started' },
            { id: '2', content: 'Task 2: Not Started' },
        ],
    },
    'inprogress': {
        name: 'In Progress',
        items: [
            { id: '3', content: 'Task 3: In Progress' },
            { id: '4', content: 'Task 4: In Progress' },
        ],
    },
    'readyForReview': {
        name: 'Ready for Review',
        items: [
            { id: '5', content: 'Task 5: Ready for Review' },
            { id: '6', content: 'Task 6: Ready for Review' },
        ],
    },
    'reviewInProgress': {
        name: 'Review in Progress',
        items: [
            { id: '7', content: 'Task 7: Review in Progress' },
            { id: '8', content: 'Task 8: Review in Progress' },
        ],
    },
    'readyToMerge': {
        name: 'Ready to Merge',
        items: [
            { id: '9', content: 'Task 9: Ready to Merge' },
            { id: '10', content: 'Task 10: Ready to Merge' },
        ],
    },
    'completed': {
        name: 'Completed',
        items: [
            { id: '11', content: 'Task 11: Completed' },
            { id: '12', content: 'Task 12: Completed' },
        ],
    },
};

function ProjectTaskBoard() {
    const [columns, setColumns] = useState(initialColumns);

    const onDragEnd = (result) => {
        const { source, destination } = result;

        if (!destination) return;

        if (source.droppableId === destination.droppableId && source.index === destination.index) return;

        const sourceColumn = columns[source.droppableId];
        const destinationColumn = columns[destination.droppableId];
        const sourceItems = Array.from(sourceColumn.items);
        const destItems = Array.from(destinationColumn.items);

        const [movedItem] = sourceItems.splice(source.index, 1);

        if (source.droppableId === destination.droppableId) {
            sourceItems.splice(destination.index, 0, movedItem);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems,
                },
            });
        } else {
            destItems.splice(destination.index, 0, movedItem);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems,
                },
                [destination.droppableId]: {
                    ...destinationColumn,
                    items: destItems,
                },
            });
        }
    };

    return (
        <>
            <h5 className='project-detail-divider'> Task Board </h5>

            <div className='drag-drop-div'>
                <DragDropContext onDragEnd={onDragEnd}>
                    {Object.entries(columns).map(([columnId, column]) => (
                        <Droppable droppableId={columnId} key={columnId}>
                            {(provided) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className='drag-drop-droppable'
                                >
                                    <h6 className='col-name'>{column.name}</h6>
                                    <div className='card_main'>
                                        {column.items.map((item, index) => (
                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                {(provided) => (
                                                    <div
                                                        className="card"
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                            ...provided.draggableProps.style,
                                                        }}
                                                    >
                                                        <p className="card_title">{item.content}</p>
                                                        <div className="card_badge">Refactoring</div>
                                                        <div className="card_footer">
                                                            <div className="card_icons">
                                                                <img src={Bookmark} className=" bookmark" />
                                                                <img src={DoubleArrowUp} className=" doubleup" />

                                                                <div className=" upvote">2</div>
                                                            </div>
                                                            <div className="card_icons">
                                                                <div className="card__id">
                                                                    <span>FC-7</span>
                                                                </div>
                                                                <div className="card__status">
                                                                    <span>PG</span>
                                                                    <span className="card__status-dot"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                    </div>
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    ))}
                </DragDropContext>
            </div>
        </>
    );
}

export default ProjectTaskBoard;
